import { keyframes, styled } from '@/styles/stitches';

const fadeInSignIn = keyframes({
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
});

export const ModalForm = styled('form', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
  gap: '$5',

  'strong , p ': {
    color: '$brightColour',
  },

  input: {
    border: 'none',
    width: '10.625rem',
    color: '$brightColour',
    background:
      'repeating-linear-gradient(90deg, $brightColour 0, $brightColour 1ch, transparent 0, transparent 1.5ch) 0 100%/100% 2px no-repeat',
    font: '32px consolas, monospace',
    letterSpacing: '.5ch',
    height: '1.875rem',
    '&:focus': {
      outline: 'none',
      color: '$brightColour',
    },
  },

  button: {
    width: '100%',
    height: '2.625rem',
    borderRadius: '$md',
    border: '2px solid $secondary',
    background: '$brightColour',
    fontWeight: 'bold',
    transition: 'color 0.2s ease-in',
    position: 'relative',
    animation: `${fadeInSignIn} ease-in 0.5s`,
    '&:hover': {
      color: '$secondary',
    },
    '&:disabled': {
      cursor: 'not-allowed',
    },
    marginTop: '$3',
  },
});

export const CodeGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  alignItems: 'center',
});

export const PasswordForm = styled('form', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
  gap: '$8',

  strong: {
    color: '$brightColour',
    fontSize: '$2xl',
  },

  div: {
    width: '100%',

    'strong.error': {
      color: 'red',
      fontSize: '$md',
    },
  },
});

export const InputGroup = styled('div', {
  borderBottom: '1px solid $brightColour',
  paddingBottom: '$1',
  display: 'flex',
  alignItems: 'center',
  gap: '$3',
  position: 'relative',
  width: '100%',

  svg: {
    position: 'absolute',
    left: 0,
  },

  input: {
    height: '1.75rem',
    zIndex: 3,
    width: '100%',
    paddingLeft: '$11',
    background: 'transparent',
    border: 0,
    outline: '0',
    color: '$brightColour',
    fontSize: '$md',
    '&:disabled': {
      cursor: 'not-allowed',
    },
    '&::placeholder': {
      color: '$brightColour',
      fontSize: '$md',
    },
  },
});

export const ModalFormFooter = styled('div', {
  display: 'flex',
  gap: '$3',
  width: '100%',
  borderBottom: '0 !important',
  '@media (max-width: 920px)': {
    flexDirection: 'column',
  },

  button: {
    width: '100%',
    height: '2.625rem',
    borderRadius: '$md',
    border: '2px solid $secondary',
    background: '$brightColour',
    fontWeight: 'bold',
    transition: 'color 0.2s ease-in',
    position: 'relative',
    animation: `${fadeInSignIn} ease-in 0.5s`,
    '&:hover': {
      color: '$secondary',
    },
    '&:disabled': {
      cursor: 'not-allowed',
    },
    marginTop: '$3',
  },

  variants: {
    isLoading: {
      true: {
        button: {
          cursor: 'not-allowed',
          '&:hover': {
            color: '#262626',
          },
        },
      },
    },
  },
});
